import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    position: relative;
    width: 100%;
    padding: ${variables.sectionPadding};

    .tabs-container {
        min-height: initial !important;
    }

    .offer-boxes {
        margin-top: 3em;

        .offer-boxes-desktop {
            display: flex;
            justify-content: flex-start;
            align-items: stretch;
            flex-wrap: wrap;

            > * {
                width: calc(33.3% - 20px);
                margin: 10px;
                text-decoration: none;
                color: black;
            }
        }
    }

    .not-found-wrapper {
        width: 100% !important;

        h1 {
            font-size: 1.2em;
            font-weight: 700;
            color: #262626;
            text-align: center;
        }
    }

    .no-offers {
        display: flex;
        justify-content: center;
        align-items: center;

        margin-top: 10em;

        .no-offers-headline {
            font-size: 1.2em;
            font-weight: 700;
            color: #262626;
            text-align: center;
        }
    }

    @media all and (max-width: ${variables.desktopXS}) {
        .offer-boxes .offer-boxes-desktop {
            flex-wrap: wrap;

            > *:not(.layout-spinner):not(.offer-boxes__not-found) {
                width: calc(50% - 20px);
            }
        }
    }

    @media all and (max-width: ${variables.tabletL}) {
        .offer-boxes .offer-boxes-desktop {
            flex-wrap: wrap;

            > * {
                margin: 10px;
                width: calc(50% - 20px);
            }
        }
    }

    @media all and (max-width: ${variables.tabletS}) {
        .offer-boxes .offer-boxes-desktop {
            > *:not(.layout-spinner):not(.offer-boxes__not-found) {
                width: 90%;
                margin: 2em auto 0;
            }
        }
    }

    @media all and (max-width: ${variables.mobileL}) {
        padding: ${variables.sectionPaddingMobile};
        overflow-x: hidden;

        .layout-container {
            width: 100%;

            .headline {
                padding: 0 5%;
            }
        }

        .offer-boxes .offer-boxes-desktop {
            display: none;
        }
    }

    @media all and (max-width: ${variables.mobileM}) {
        .children {
            .tabs-container {
                > .nav {
                    display: flex;
                    justify-content: flex-start !important;
                    align-items: flex-start !important;
                    overflow-x: scroll !important;
                    position: relative !important;
                    width: 100%;

                    .tab {
                        margin: 0 5.5vw;
                    }

                    &:before {
                        width: 100% !important;
                    }

                    &::-webkit-scrollbar {
                        display: none;
                    }
                }
            }
        }
    }

    @media all and (max-width: ${variables.mobileS}) {
        .children {
            .tabs-container {
                > .nav {
                    .tab {
                        margin: 0 5vw;
                    }
                }
            }
        }
    }

    @media all and (max-width: ${variables.mobileXS}) {
        .children {
            .tabs-container {
                > .nav {
                    .tab {
                        margin: 0 6vw;
                    }
                }
            }
        }
    }
`;
